import {makeResource} from 'app/infrastructure/repository'
import { Mean } from './_models';

const ENDPOINT = 'means';

export default makeResource<Mean>(ENDPOINT);

